/**
 * Code by Mathieu VANBESELAERE for ->
 * @copyright Copyright (c) Agence ink
 */

//// Module summary ////
// => This module contains the JS required by the home page, and its gsap animations

////////////////////////// GSAP animation modules importation ////////////////////////////////
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
// import ScrollSmoother from "gsap/ScrollSmoother"; gsap.registerPlugin(ScrollSmoother);
// import ScrollToPlugin from "gsap/ScrollToPlugin"; gsap.registerPlugin(ScrollToPlugin);
// import DrawSVGPlugin from "gsap/DrawSVGPlugin"; gsap.registerPlugin(DrawSVGPlugin);
// import MorphSVGPlugin from "gsap/MorphSVGPlugin"; gsap.registerPlugin(MorphSVGPlugin);
// import SplitText from "gsap/SplitText"; gsap.registerPlugin(SplitText);
//////////////////////////////////////////////////////////////////////////////////////////////

export const home = () => {
    const tabletTrigger = 991;

    let home = document.querySelector(".page-accueil");
    if (home) {
        // [ANIMATION] GROWING SCREEN
        // -> The media grows until it covers the whole section
        let heroGrower = document.querySelector('.hero-video-wrapper');
        let secondGrower = document.querySelector('.video-wrapper');
        if (heroGrower) {
            gsap.to(heroGrower, {
                width: "100%",
                height: "100vh",
                borderRadius: 0,
                ease: "none",
                scrollTrigger: {
                    trigger: heroGrower.parentNode.parentNode,
                    start: "top top",
                    end: "80% bottom",
                    scrub: 0.75,
                    markers: false,
                },
            });
        } 

        if (secondGrower) {
            let growerAnim = gsap.to(secondGrower, {
                width: "100%",
                height: "100vh",
                borderRadius: 0,
                ease: "none",
                duration: .6,
                scrollTrigger: {
                    trigger: secondGrower.parentNode,
                    start: "top top",
                    markers: false,
                    onLeaveBack: () => growerAnim.reverse(),
                },

            });
        }

        // [ANIMATION] SERVICES LOGO
        // -> Apparition des logos de service en stagger
        let serviceLogos = document.querySelectorAll(".service-link");
        if (serviceLogos.length) {
            gsap.to(serviceLogos, {
                autoAlpha: 1,
                y: 0,
                stagger: 0.25,
                duration: 0.75,
                scrollTrigger: {
                    trigger: serviceLogos,
                    start: "top 80%",
                },
                ease: "power2.out",
            });
        }

        // [ANIMATION] HORIZONTAL SCROLL
        // -> The project section will stop its vertical scroll
        // -> The section will scroll horizontally
        // -> The vertical scroll will then resume its behavior
        let projectsTrack = document.querySelector(".project-track");

        if (projectsTrack) {
            let realisationsSection = document.querySelector(".section_realisations");
            let threeFourthOfScreen = (window.innerWidth * 75) / 100; // Will stop the track earlier!
            let trackTargetOffset = -Math.abs(
                projectsTrack.offsetWidth - threeFourthOfScreen
            ); // Last bits of the track we won't scroll

            gsap.to(projectsTrack, {
                x: trackTargetOffset,
                ease: "none",
                scrollTrigger: {
                    trigger: realisationsSection,
                    start: window.innerHeight * 1.7 + " bottom", // trigger start for track
                    end: "bottom-=" + window.innerHeight * 1.7 + " top",
                    scrub: 1,
                    markers: false,
                },
            });
        }

        // [ANIMATION] LINES !!! à changer car la ligne du haut est now sticky..
        let lines = document.querySelectorAll(".about-line");

        if (lines.length) {
            for (let currentLine of lines) {
                let lineMaxLength = currentLine.offsetWidth;
                let lineMinPercent = Math.floor(Math.random() * 33) + 33; // 33 - 66
                let lineMinLength = (lineMaxLength * lineMinPercent) / 100;
                gsap.from(currentLine, {
                    width: lineMinLength,
                    scrollTrigger: {
                        trigger: currentLine,
                        start: "top bottom",
                        end: "top top",
                        scrub: 1,
                        markers: false,
                    },
                });
            }
        }

        // [ANIMATION] MARQUEE
        // -> The scrolling is already handled by Webflow's css
        // -> The below animation "reels" the marquees in and autoAlphas the logos to 1
        let marquees = document.querySelectorAll(".marquee");
        if (marquees.length) {
            let firstMarquee = marquees[0];
            let secondMarquee = marquees[1];
            let firstMarqueeContent = firstMarquee.querySelectorAll(".marquee-content");
            let secondMarqueeContent = secondMarquee.querySelectorAll(".marquee-content");
            let responsiveStart = (window.innerWidth <= tabletTrigger) ? "top 66%" : "top 25%";
            
            let TL_MARQUEES = gsap.timeline({
                defaults: {
                    duration: 0.75,
                },
                scrollTrigger: {
                    trigger: firstMarquee,
                    start: responsiveStart,
                    markers: false,
                },
            });

            // A) Set to initial position
            gsap.set(firstMarquee, { x: "-100%" });
            gsap.set(secondMarquee, { x: "100%" });
            gsap.set(firstMarqueeContent, { autoAlpha: 0 });
            gsap.set(secondMarqueeContent, { autoAlpha: 0 });

            // B) Timeline
            TL_MARQUEES.to(firstMarquee, { x: 0 })
                .to(secondMarquee, { x: 0 })
                .to(firstMarqueeContent, { autoAlpha: 1 })
                .to(secondMarqueeContent, { autoAlpha: 1 }, ">-=.5");
        }

        // [FORCE AUTOPLAY]
        let animatedThumbnailsContainer = document.querySelectorAll(".hero-video-wrapper, .section_about-video");
        if (animatedThumbnailsContainer.length) {
            document.addEventListener("DOMContentLoaded", () => {
                setTimeout(() => {
                    for (let animatedThumbnail of animatedThumbnailsContainer) {
                        let videos = animatedThumbnail.querySelectorAll("video");
                        for (let video of videos) {
                            video.play();
                        }
                    }
                }, 500);
            });
        }
    }

    // [LIGHTBOX] Toggle
    let lightboxBtn = document.querySelector(".watch-video");
    if (lightboxBtn) {
        let lightbox = document.querySelector(".play-lightbox");
        let lightboxCloseBtn = lightbox.querySelector(".close-lightbox");
        lightboxBtn.addEventListener("click", () => {
            document.body.style.overflow = "hidden";
            lightbox.style.display = "flex";
        });

        lightboxCloseBtn.addEventListener("click", () => {
            if (document.querySelector('.plyr--playing')) {
                lightbox.querySelector('[data-plyr="play"]').click();
            }
            lightbox.style.display = "none";
            document.body.style.overflow = "visible";
        });
    }

    return;
};
